import React, { useContext } from 'react';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { expandAll } from 'TaxonomyMapper/utils';
import { getLeafNodesFromTree } from 'TaxonomyMapper/utils';
import { SearchMenu } from '../../TaxonomyMapper/SearchMenu';
import { CompanySortableTree } from '../../TaxonomyMapper/CompanySortableTree';
import {
  ActionButton,
  ButtonsWrapper,
  Container,
  Title,
  TreeContainer,
  TreeNav,
  TreeNavActions,
} from './TaxonomyTree.styles';
import { Divider } from '../TaxonomyPreview.styles';

export default ({
  companyTreeData = null,
  currencySymbol,
  onSelectTreeItem,
  setCompanyTreeData,
  searchQuery,
  setSearchQuery,
}) => {
  const queryContext = useContext(QueryStringContext);
  const { selectedTreeItem } = queryContext;

  const searchOptions = companyTreeData && companyTreeData.length
    ? getLeafNodesFromTree(companyTreeData)
    : [];
  return (
    <Container>
      <TreeNav>
        <Title>
          Taxonomy tree
        </Title>
        <TreeNavActions>
          <ButtonsWrapper>
            <SearchMenu
              onSearch={setSearchQuery}
              offsetRight={-92}
              options={searchOptions}
              currencySymbol={currencySymbol}
            />
          </ButtonsWrapper>
          <Divider />
          <ActionButton
            iconName="unfold_more"
            onClick={() => {
              setCompanyTreeData(expandAll(companyTreeData))
            }}
          />
          <ActionButton
            iconName="unfold_less"
            onClick={() => {
              setCompanyTreeData(expandAll(companyTreeData, false))
            }}
          />
        </TreeNavActions>
      </TreeNav>
      <TreeContainer>
        <CompanySortableTree
          dragDisabled
          currencySymbol={currencySymbol}
          data={companyTreeData}
          onChange={(data) => {
            setCompanyTreeData(data);
          }}
          searchQuery={searchQuery}
          onTreeItemClick={(node) => {
            if (selectedTreeItem && selectedTreeItem === node.id) {
              onSelectTreeItem(null);
            } else {
              onSelectTreeItem(node.id);
            }
          }}
          selectedTreeItem={selectedTreeItem}
        />
      </TreeContainer>
    </Container>
  )
}
